import SigningResults from '@/pages/tuoke/signingResults.vue'
export default [
  {
    path: '/tuoke/SigningResults',
    component: SigningResults,
    meta: {
      title: '签约结果',
      whiteList: true,
    },
  },
]
